import { PaginationMeta } from '../types/pagination';

export const PAGE_SIZE = 10;
export const FIRST_PAGE = 1;

export const PAGINATION_META_DEFAULT: PaginationMeta = {
	currentPage: FIRST_PAGE,
	pageSize: PAGE_SIZE,
	totalPages: 0,
	totalItems: 0,
};

export const PAGINATION_META_LOGS: PaginationMeta = {
	currentPage: FIRST_PAGE,
	pageSize: 200,
	totalPages: 0,
	totalItems: 0,
};
